import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import TicketsIndex from "@/pages/TicketsIndex";
import TicketDetail from "@/pages/TicketDetail";
import PlanIndex from "@/pages/PlanIndex";
import PlanDetail from "@/pages/PlanDetail";
import HighlightsIndex from "@/pages/HighlightsIndex";
import HighlightDetail from "@/pages/HighlightDetail";
import GuidesIndex from "@/pages/GuidesIndex";
import GuideDetail from "@/pages/GuideDetail";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/tickets" element={<TicketsIndex />} />
          <Route path="/tickets/:slug" element={<TicketDetail />} />
          <Route path="/plan" element={<PlanIndex />} />
          <Route path="/plan/:slug" element={<PlanDetail />} />
          <Route path="/highlights" element={<HighlightsIndex />} />
          <Route path="/highlights/:slug" element={<HighlightDetail />} />
          <Route path="/guides" element={<GuidesIndex />} />
          <Route path="/guides/:slug" element={<GuideDetail />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
